import { Indicators } from "./indicators";

export function getChartColor(
	percentage: number,
	indicatorsDetail: Indicators,
	key: keyof Indicators
) {
	return indicatorsDetail[key].getChartColor(percentage);
}
